/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Exceptional_Planning_Copy_TitleInputs */



/**
* | output |
* | --- |
* | "Duplicate exceptional planning" |
*
* @param {Air_Handler_Unit_Exceptional_Planning_Copy_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_exceptional_planning_copy_title = /** @type {((inputs?: Air_Handler_Unit_Exceptional_Planning_Copy_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Exceptional_Planning_Copy_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Duplicate exceptional planning")
	return /** @type {LocalizedString} */ ("Dupliquer le planning exceptionnel")
});